import { EOrganizedBy } from 'detailsv2/structure';
import yup from 'utils/yup';

import { wrongTimeFormatError } from '../../constants';
import { optionalTimeFormatValidation, optionalTimeLengthValidation } from '../../functions';

export const flightAPIValidationSchema = (organizedBy: EOrganizedBy) => {
  const formFields: any = {
    // attachedPages: yup.array().transform((arr: any[]) => arr.filter(Boolean)),
    // data: yup.object().shape({
    //   airline: yup.object().required('Please fill in this field'),
    //   flightNumber: yup.string().required('Please fill in this field'),
    // }),
  };

  if (organizedBy === EOrganizedBy.Date) {
    formFields.datesRange = yup.object().shape({
      start: yup.string().required('Please fill in this field').nullable(),
    });
  }

  if (organizedBy === EOrganizedBy.Day) {
    formFields.daysRange = yup.object().shape({
      start: yup.number().required('Please fill in this field').nullable(),
    });
  }

  return yup.object().shape({
    ...formFields,
  });
};

export const flightManualValidationSchema = (organizedBy: EOrganizedBy) => {
  const formFields: any = {
    attachedPages: yup.array().transform((arr: any[]) => arr.filter(Boolean)),
    data: yup.object().shape({
      departureFrom: yup.string().required('Please fill in this field'),
      arrivalTo: yup.string().required('Please fill in this field'),
      departureTime: yup
        .string()
        .test('dtime-len', wrongTimeFormatError, optionalTimeLengthValidation)
        .test('is-dtime-valid', wrongTimeFormatError, optionalTimeFormatValidation),
      arrivalTime: yup
        .string()
        .test('atime-len', wrongTimeFormatError, optionalTimeLengthValidation)
        .test('is-atime-valid', wrongTimeFormatError, optionalTimeFormatValidation),
    }),
  };

  if (organizedBy === EOrganizedBy.Date) {
    formFields.datesRange = yup.object().shape({
      start: yup.string().required('Please fill in this field').nullable(),
      end: yup.string().required('Please fill in this field').nullable(),
    });
  }

  if (organizedBy === EOrganizedBy.Day) {
    formFields.daysRange = yup.object().shape({
      start: yup.number().required('Please fill in this field').nullable(),
      end: yup.number().required('Please fill in this field').nullable(),
    });
  }

  return yup.object().shape({
    ...formFields,
  });
};
